export const CashFlowReport = {
  en: {
    From: 'From (inclusive)',
    Till: 'Till (inclusive)',
    Articles: 'Articles',
    Income: 'Income',
    Expenses: 'Expenses',
    Payments: 'Payments',
    'Total income': 'Total income',
    'Total expenses': 'Total expenses',
    'Total payments': 'Total payments',
    Profit: 'Profit',
    Services: 'Services',
    Cards: 'Cards',
    Products: 'Products',
    Certificates: 'Certificates',
    Salary: 'Salary',
    Refunds: 'Refunds',
    'Deposit top-ups': 'Deposit top-ups',
    'Deposit refunds': 'Deposit refunds',
    'Goods purchase': 'Goods purchase',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    Location: 'Location',
    'Failed to load the report': 'Failed to load the report',
    'Something went wrong while fetching the data':
      'Something went wrong while fetching the data',
    'Try again': 'Try again',
    'Clear filter': 'Clear filter',
  },
  uk: {
    From: 'З (включно)',
    Till: 'До (включно)',
    Articles: 'Статті',
    Income: 'Надходження',
    Expenses: 'Витрати',
    Payments: 'Виплати',
    'Total income': 'Разом надходження',
    'Total expenses': 'Разом витрати',
    'Total payments': 'Разом виплати',
    Profit: 'Прибуток',
    Services: 'Сервіси',
    Cards: 'Картки',
    Products: 'Товари',
    Certificates: 'Сертифікати',
    Salary: 'Зарплата',
    Refunds: 'Повернення',
    'Deposit top-ups': 'Поповнення депозиту',
    'Deposit refunds': 'Повернення депозиту',
    'Goods purchase': 'Закупівля товарів',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    Location: 'Локація',
    'Failed to load the report': 'Не вдалося завантажити звіт',
    'Something went wrong while fetching the data':
      'Щось пішло не так під час завантаження даних',
    'Try again': 'Спробувати ще раз',
    'Clear filter': 'Очистити фільтр',
  },
};
